import React from 'react';
import classnames from 'classnames';
import Button from './Button';
import styles from './RoundedPrimaryButton.scss';
const RoundedPrimaryButton = ({ additionClasses, ...props }) => (<Button additionClasses={classnames(additionClasses, 'btn-rounded', styles.ButtonSize)} buttonStyle="primary" {...props}/>);
export default RoundedPrimaryButton;
